import { Container, Card, CardHeader, Row, Col } from 'reactstrap'
import ProfileIcon from 'assets/qualified_icon.png'
import BadgeYellow from 'assets/badge_icon_1.svg'
import BadgePink from 'assets/badge_icon_2.svg'
import CashAwards from './CashAwards'
import NearestBranch from '../EarlyBenefits/NearestBranch'
import PercentageDekstop from 'assets/percentage-dekstop.png'
import PercentageMobile from 'assets/grade-st-360.png'
import PercentageMobile560 from 'assets/grade-st-500.png'
import { TERMS_AND_CONDITIONS } from 'constants/externalLinks'
import {AKTHE_TERMS_AND_CONDITIONS} from 'constants/externalLinks'
import { useEffect } from 'react'
import { connect } from 'react-redux'

const mapStateToProps = (state) => ({
  profileInfo: state?.profileData,
  dashboardInfo: state?.dashboardData
})

const QualifiedCard = (props) => {
  const handleTnClick = () => {
    window.open((props?.dashboardInfo?.static_data?.exam_type === "ANTHE"? TERMS_AND_CONDITIONS : AKTHE_TERMS_AND_CONDITIONS),'_blank')
    //window.open(props?.dashboardInfo?.static_data?.termsLink || TERMS_AND_CONDITIONS, '_blank')
  }
  let eligibleRankForCashAward = {};
  if (props?.dashboardInfo?.static_data?.exam_type === "AKTHE") {
    eligibleRankForCashAward = {
    'VII': 3,
    'VIII': 3,
    'IX': 3,
    'X': 3,
    'XI': 3,
    'XII': 3,
    'XII Passed': 3
  };
  }
  if (props?.dashboardInfo?.static_data?.exam_type === "ANTHE") {
    eligibleRankForCashAward = {
    'V': 50,
    'VI': 50,
    'VII': 250,
    'VIII': 250,
    'IX': 250,
    'X': 250,
    'XI': 100,
    'XII': 100,
    'XII Passed': 100
  };
  }


  if (props?.profileInfo?.anthetwo) {
    eligibleRankForCashAward = {
      'V': 50,
      'VI': 50,
      'VII': 50,
      'VIII': 50,
      'IX': 50,
      'X': 50,
      'XI': 25,
      'XII': 25,
      'XII Passed': 25
    };
  }

  const air = props?.result?.data?.scholarship?.allIndiaRank ? Number(props?.result?.data?.scholarship?.allIndiaRank) : 0;
  const classStudying = props?.result?.data?.profile?.class_studying || "";

  useEffect(() => {
    const metaTag = document.createElement('meta');
    metaTag.name = 'format-detection';
    metaTag.content = 'telephone=no';
    document.head.appendChild(metaTag);

    // Cleanup: remove the meta tag when the component unmounts
    return () => {
      document.head.removeChild(metaTag);
    };
  }, []);
  return (
    <div className='bg-light'>
      <Container className="px-lg-0 px-xl-0 px-3 p-3 pb-lg-0 pb-xl-3 mh-100 maxw-11">
        <Card className='border-0'>
          <CardHeader className="bg-aqua-60 rounded-top border-0 py-2 px-lg-4">
            <div className="d-flex align-items-center text-align-center py-2">
              <p className="text-white font-size-sm-mds fw-lighter font-size-xs m-0">
                {(props?.result?.data?.scholarship?.remarks || "").replace('.', ' ')}
                {props?.result?.data?.grade && <span className='text-yellow'>(Grade {props?.result?.data?.grade})</span>}
              </p>
            </div>
          </CardHeader>
          <div className="qualified_section">
            <div className='d-lg-flex align-items-center pb-2 bd_quali '>
              <div className='mw-100 w-xl-4 w-lg-5 w-md-6 d-flex bd_quali1 mb-md-2'>
                <div className='pe-lg-3 pe-2 pf_icon'>
                  <img src={ProfileIcon} alt="students-profile-illustration" />
                </div>
                <div className='w-lg-7 mw-100'>
                  <h6 className='text-black fw-lighter qauli_st_name text-capitalize'> {props?.result?.data?.profile?.name} </h6>
                  <div className='d-flex justify-content-between align-items-baseline'>
                    <p className='text-grey fw-lighter mb-0 quali_details'>PSID : <strong className='text-black'>{props?.userpsid || '--'}</strong></p><span className='divider_details'>|</span><p className='text-grey fw-lighter mb-0 quali_details'>Roll No : <strong className='text-black'>{props?.result?.data?.profile?.roll_number}</strong></p>
                  </div>
                </div>
                <div className='br_strip'></div>
              </div>
              <>
              {props?.dashboardInfo?.static_data?.exam_type === "ANTHE" && (
              <div className='w-xl-6 w-md-6 w-lg-5 mw-100 d-lg-flex justify-content-around '>
                <div className='br_strip d-none d-xs-block'></div>
                <div className='d-flex justify-content-between mt_details align-items-center'>
                  <p className='font-size-lg-xs font-size-xs text-dark-blue-8 fw-500 mb-0'><img src={BadgeYellow} alt="badge-illustration" className=' pe-2' />ANTHE Rank ({props?.result?.data?.scholarship?.city || "City"}) :</p><p className='font-size-sm text-dark-blue-8 fw-500 mb-0 ps-1'> <strong className='fw-700 font-size-sm'>{(props?.result?.data?.scholarship?.cityRank != "null" && props?.result?.data?.scholarship?.cityRank != "") ? props?.result?.data?.scholarship?.cityRank : "--"}</strong></p>
                </div>
                <div className='d-flex justify-content-between mt_details align-items-center mt-0'>
                  <p className='font-size-lg-xs font-size-xs text-dark-blue-8 fw-500 mb-0'><img src={BadgeYellow} alt="badge-illustration" className=' pe-2' />ANTHE Rank ({props?.result?.data?.profile?.state}) :</p><p className='font-size-sm text-dark-blue-8 fw-500 mb-0 ps-1'> <strong className='fw-700 font-size-sm'>{props?.result?.data?.scholarship?.stateRank}</strong></p>
                </div>
                <div className='d-flex justify-content-between align-items-center'>
                  <p className='font-size-lg-xs font-size-xs text-dark-blue-8 fw-500 mb-0'><img src={BadgePink} alt="badge-illustration" className='pe-2' />All India ANTHE Rank : </p><p className='font-size-sm text-dark-blue-8 fw-500 mb-0 ps-1'><strong className='fw-700 font-size-sm'>{props?.result?.data?.scholarship?.allIndiaRank}</strong></p>
                </div>
              </div>
              )}
              {props?.dashboardInfo?.static_data?.exam_type === "AKTHE" && (
              <div className='w-xl-6 w-md-6 w-lg-5 mw-100 d-lg-flex justify-content-end'>
                <div className='br_strip d-none d-xs-block'></div>
                <div className='d-flex justify-content-between mt_details align-items-center'>
                  <p className='font-size-lg-md font-size-xs text-dark-blue-8 fw-500 mb-0'>
                    <img src={BadgeYellow} alt="badge-illustration" className=' pe-2' />
                    ANTHE Rank (Kashmir) :
                  </p>
                  <p className='font-size-sm text-dark-blue-8 fw-500 mb-0 ps-1'>
                    <strong className='fw-700 font-size-lg-lg font-size-sm'>
                    {props?.result?.data?.scholarship?.stateRank}
                    </strong>
                  </p>
                </div>
              </div>
              )}

              </>
            </div>
            <div className='d-lg-flex justify-content-between pt-q'>
              <p className='text-dark-grey font-size-sm mb-0'>For detailed result visit branch</p>
              <p className='text-grey font-size-xs mb-0 cursor-pointer' onClick={handleTnClick}>*Terms and conditions applicable</p>
            </div>
            <p className='text-grey' style={{fontSize:"11px", margin:"15px 0 0 0"}}>**By viewing this result, you (or your parent/guardian, if you are under 18) hereby provide consent to AESL to contact you via phone, email, SMS, or other communication channels for the purpose of sharing information, updates, and promotional material related to our services until 31st July 2026. You have the right to withdraw your consent at any time by contacting us at <a className='text-decoration-none' href='mailto:care@aesl.in'>care@aesl.in</a>.</p>
          </div>
        </Card>
        <div className='mt-4 grade_st_1100'>
          <img src={PercentageDekstop} alt="percentage" className='img-fluid' />
        </div>
      </Container>
      <div>
        <img src={PercentageMobile560} alt="percentage" className='img-fluid grade_st_500 percntage' />
      </div>
      <div>
        <img src={PercentageMobile} alt="percentage" className='img-fluid grade_st_360 percntage' />
      </div>
      {(air && classStudying && eligibleRankForCashAward[classStudying] && air <= eligibleRankForCashAward[classStudying]) ? <CashAwards class_studying={props?.result?.data?.profile?.class_studying} /> : <></>}
      <NearestBranch />
    </div>
  )

}

export default connect(mapStateToProps)(QualifiedCard);